import script from "./SimilarTarget.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimilarTarget.vue?vue&type=script&setup=true&lang=ts"

import "./SimilarTarget.vue?vue&type=style&index=0&id=343b8858&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-343b8858"]])

export default __exports__